export const getProdCycles = ({ prodCycles }) => prodCycles.prodCycles;
